// extracted by mini-css-extract-plugin
export var callCard = "_rg-0";
export var callMessageButton = "_rg-1";
export var helpIcon = "_rg-3";
export var helpIconContainer = "_rg-4";
export var verticalDivider = "_rg-2";